<template>
    <div class="row">
      <div class="col-12 card">
        <h4>Контрагенты</h4>
        <div class="row justify-content-space-between">
            <div class="col-12">
              <div class="row" v-if="Partners">
                <PartnersList/>
              </div>
              <div class="row" v-else>
                Идёт загрузка...
              </div>
            </div>
        </div>
      </div>
    </div>
</template>
  
  <script>
    import PartnersList from "@/components/Ecology/Partners/PartnersList.vue";

    export default {
      components: { PartnersList },
      data() {
        return {
          title: "Контрагенты",
        }
      },
      computed: {
        currentUser() {
          return this.$store.state.auth.user;
        },
        Partners() {
          return this.$store.state.eco_partners
        },
      },
      methods: {

      },
      created() {
          this.$store.dispatch("fetchEcologyPartners");
      },
    };
  </script>
  